const smoothScroll = (): void => {
  const allLinks = document.querySelectorAll<HTMLAnchorElement>('a');
  const smoothScrollTrigger = Array.from(allLinks).filter(link => link.href.includes('#'));

  smoothScrollTrigger.forEach((anchor) => {
    anchor.addEventListener('click', (e: Event) => {
      e.preventDefault();
      const href = anchor.getAttribute('href');
      if (!href) return;

      const hash = href.split('#')[1];
      const targetElement = document.getElementById(hash);

      if (!targetElement) {
        if (hash === '') {
          window.scrollTo({
            top: 0,
            behavior: 'smooth',
          });
          return;
        } else {
          window.location.href = href;
          return;
        }
      }

      const rect = targetElement.getBoundingClientRect().top;
      const offset = window.pageYOffset;
      const gap: number = 90;

      const target = rect + offset - gap;
      window.scrollTo({
        top: target,
        behavior: 'smooth',
      });
    });
  });
};

export default smoothScroll;
